import css from 'styled-jsx/css';

const styles = css.global`#santander-carousel {
  background: #C00;
  padding: 24px 0;
  max-height: 615px;
  height: calc(100vh - 58px);
  min-height: 473px;
}

#santander-carousel .santander-carousel-contain {
  width: 100%;
  position: relative;
}

#santander-carousel .santander-carousel-contain .slide a {
  display: flex;
  width: calc(100% - 1px);
}

#santander-carousel .bg-banner {
  width: 100%;
  max-height: 510px;
  height: calc(100vh - 175px);
  min-height: 345px;
}

#santander-carousel .bg-banner img {
  width: 100%;
  object-fit: cover;
  max-height: 510px;
  height: calc(100vh - 175px);
  min-height: 345px;
  border-radius: 4px;
  object-position: top;
}

#santander-carousel .conteudo-banner {
  position: absolute;
  top: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #CE0505 100%);

  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
  max-height: 510px;
  height: calc(100vh - 175px);
  min-height: 345px;
}

#santander-carousel .conteudo-banner .banner-title {
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
  margin: 0;
  max-width: 600px;
}

#santander-carousel .conteudo-banner .banner-subtitle {
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
  /* max-width: 510px; */
}

#santander-carousel .conteudo-banner .banner-subtitle b {
  font-weight: 600;
}

#santander-carousel .conteudo-banner .banner-saber-mais {
  color: #fff;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#santander-carousel .home-pagination {
  margin-top: 27px;
}

#santander-carousel .pagination-container .bullet.active,
#santander-carousel .pagination-container .bullet[selected] {
  background-color: #000;
}

#santander-carousel .pagination-container .bullet {
  background-color: #999999;
}

#santander-carousel .home-pagination .embla__prev {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_left_white.svg);
  background-size: 24px 24px;
}

#santander-carousel .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_right_white.svg);
  background-size: 24px 24px;
}

@media (min-width: 800px) {
  
}

@media (min-width: 992px) {
  #santander-carousel .conteudo-banner {
    /* background: linear-gradient(90deg, rgba(153, 0, 0, .5)0%, rgba(153, 0, 0, .37)56.94%, rgba(153, 0, 0, 0)100%); */
    background: linear-gradient(90deg, rgba(153, 0, 0, 0.50) 0%, rgba(153, 0, 0, 0.37) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);

;
    padding: 32px 16px;
  }
  #santander-carousel {
    padding: 48px 0;
    max-height: 657px;
    height: calc(100vh - 140px);
    min-height: 375px;
  }

  #santander-carousel .bg-banner {
    max-height: 510px;
    height: calc(100vh - 265px);
    min-height: 255px;
  }

  #santander-carousel .bg-banner img {
    max-height: 510px;
    height: calc(100vh - 265px);
    min-height: 255px;
  }

  #santander-carousel .conteudo-banner {
    max-height: 510px;
    height: calc(100vh - 265px);
    min-height: 256px;
  }
}`;

export default styles;